(function () {
  'use strict';

  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var f = format || '£{{amount}}';
    return f.replace(/\{\{\s*amount\s*\}\}/, withCommas + '.' + parts[1])
            .replace(/\{\{\s*amount_no_decimals\s*\}\}/, withCommas)
            .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, parts[0] + ',' + parts[1])
            .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, parts[0]);
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  /* Menus: close on outside click or Escape */
  document.addEventListener('click', function (e) {
    document.querySelectorAll('[data-menu][open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-menu][open]').forEach(function (d) { d.removeAttribute('open'); d.querySelector('summary').focus(); });
  });

  /* Filters panel: always open on wide screens, collapsed on phones */
  var fpanel = document.querySelector('[data-filters-panel]');
  if (fpanel && window.matchMedia) {
    var wide = window.matchMedia('(min-width: 800px)');
    var syncPanel = function () { if (wide.matches) fpanel.open = true; };
    syncPanel();
    if (wide.addEventListener) wide.addEventListener('change', syncPanel);
  }

  /* Filters: submit on change (Apply button remains for no-JS) */
  var filters = document.querySelector('[data-filters]');
  if (filters) {
    var apply = filters.querySelector('[data-filters-apply]');
    if (apply) apply.hidden = true;
    var timer;
    filters.addEventListener('change', function () {
      clearTimeout(timer);
      timer = setTimeout(function () { filters.requestSubmit ? filters.requestSubmit() : filters.submit(); }, 250);
    });
  }

  /* Gallery thumbnails */
  var gallery = document.querySelector('[data-gallery]');
  function showMedia(id) {
    if (!gallery) return;
    var thumb = gallery.querySelector('[data-media-id="' + id + '"]');
    var main = gallery.querySelector('.gallery__main img'); /* image_tag drops empty data-* attributes, so select by structure */
    if (!thumb || !main) return;
    var srcset = thumb.getAttribute('data-srcset');
    if (srcset) main.srcset = srcset; else main.removeAttribute('srcset');
    main.src = thumb.getAttribute('data-src');
    gallery.querySelectorAll('.gallery__thumb').forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
  }
  if (gallery) {
    gallery.addEventListener('click', function (e) {
      var t = e.target.closest('[data-media-id]');
      if (t) showMedia(t.getAttribute('data-media-id'));
    });
  }

  /* Product form: variant selection + AJAX add */
  var pf = document.querySelector('product-form');
  if (pf) {
    var form = pf.querySelector('form');
    var variants = JSON.parse(pf.querySelector('[data-variants]').textContent);
    var select = pf.querySelector('[data-variant-select]');
    var hidden = pf.querySelector('[data-variant-id]');
    var radios = pf.querySelectorAll('input[type=radio][data-opt-index]');
    var money = pf.getAttribute('data-money-format');
    var addBtns = document.querySelectorAll('[data-add], [data-add-sticky]');
    var err = pf.querySelector('[data-form-error]');
    var ok = pf.querySelector('[data-form-success]');

    if (select && hidden) { select.disabled = true; hidden.disabled = false; }

    var optNames = [];
    pf.querySelectorAll('.opt legend').forEach(function (l, i) { optNames[i] = l.firstChild.textContent.trim().toLowerCase(); });

    function selectedOptions() {
      var out = [];
      radios.forEach(function (r) { if (r.checked) out[parseInt(r.getAttribute('data-opt-index'), 10)] = r.value; });
      return out;
    }
    function findVariant(opts) {
      return variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
    }
    function missingOption(opts) {
      for (var i = 0; i < optNames.length; i++) { if (!opts[i]) return optNames[i]; }
      return null;
    }
    function markUnavailable(opts) {
      radios.forEach(function (r) {
        var i = parseInt(r.getAttribute('data-opt-index'), 10);
        var test = opts.slice();
        test[i] = r.value;
        var others = true;
        for (var j = 0; j < optNames.length; j++) { if (j !== i && !test[j]) others = false; }
        var v = others ? findVariant(test) : null;
        r.parentNode.classList.toggle('is-unavailable', !!others && !(v && v.available));
      });
    }
    function setButtons(text, disabled) {
      addBtns.forEach(function (b) {
        b.disabled = disabled;
        var label = b.querySelector('[data-add-label]');
        if (label) label.textContent = text;
      });
    }
    /* Choosing a size must not swap the gallery away from the first (model) photo; only a colour change or re-tapping a colour does */
    function colourKey(opts) { return opts.filter(function (o, i) { return optNames[i] && optNames[i].indexOf('size') < 0; }).join('|'); }
    var lastColour = colourKey(selectedOptions());
    function render(force) {
      var opts = selectedOptions();
      var missing = missingOption(opts);
      var variant = missing ? null : findVariant(opts);
      selectedOptions().forEach(function (v, i) {
        var l = pf.querySelector('[data-opt-label="' + i + '"]');
        if (l) l.textContent = v;
      });
      markUnavailable(opts);
      /* Show the picked colour's image straight away, even before a size is chosen */
      var partial = variants.find(function (v) { return v.featured_media && v.options.every(function (o, i) { return !opts[i] || o === opts[i]; }); });
      var ck = colourKey(opts);
      if (partial && (force === true || ck !== lastColour)) showMedia(partial.featured_media.id);
      lastColour = ck;
      if (missing) { hidden.value = ''; setButtons('Choose a ' + missing, true); return; }
      setButtons(!variant ? 'Unavailable' : variant.available ? 'Add to cart' : 'Sold out', !(variant && variant.available));
      if (variant) {
        hidden.value = variant.id;
        var html = '<div class="price' + (variant.compare_at_price > variant.price ? ' price--sale' : '') + '"><span class="price__now">' + formatMoney(variant.price, money) + '</span>' +
          (variant.compare_at_price > variant.price ? '<s class="price__was">' + formatMoney(variant.compare_at_price, money) + '</s>' : '') + '</div>';
        document.querySelectorAll('[data-price], [data-price-sticky]').forEach(function (el) { el.innerHTML = html; });
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState(null, '', url.toString());
      }
    }
    radios.forEach(function (r) {
      r.addEventListener('change', function () {
        ok.hidden = true; err.hidden = true;
        render();
      });
      /* Re-tapping the already-selected colour brings its image back after browsing thumbnails */
      r.addEventListener('click', function () { if (r.checked) render(optNames[parseInt(r.getAttribute('data-opt-index'), 10)].indexOf('size') < 0); });
    });
    if (radios.length) markUnavailable(selectedOptions());

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      err.hidden = true; ok.hidden = true;
      var opts = selectedOptions();
      var missing = radios.length ? missingOption(opts) : null;
      if (missing) { err.textContent = 'Choose a ' + missing + '.'; err.hidden = false; return; }
      var variant = radios.length ? findVariant(opts) : variants[0];
      if (!variant || !variant.available) { err.textContent = 'That option is not available.'; err.hidden = false; return; }
      setButtons('Adding…', true);
      var body = new FormData(form);
      body.set('id', variant.id);
      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST', body: body, headers: { 'Accept': 'application/json' }
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
        .then(function (res) {
          if (!res.ok) { throw new Error(res.json.description || res.json.message || 'Could not add to cart.'); }
          ok.hidden = false;
          addBtns.forEach(function (b) { b.classList.add('is-added'); });
          setButtons('Added ✓', true);
          setTimeout(function () { addBtns.forEach(function (b) { b.classList.remove('is-added'); }); restore(); }, 2000);
          return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { updateCartCount(c.item_count); });
        })
        .catch(function (ex) { err.textContent = ex.message; err.hidden = false; restore(); });
    });
    function restore() {
      if (radios.length) { render(); return; }
      setButtons(variants[0].available ? 'Add to cart' : 'Sold out', !variants[0].available);
    }
  }

  /* Quiet entrance: fade below-the-fold headings and cards in once (off for reduced motion) */
  function reveal(root) {
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -40px 0px' });
    (root || document).querySelectorAll('.section__head, .grid > *, .tiles > *, .split, .why__grid').forEach(function (el) {
      if (el.getBoundingClientRect().top < window.innerHeight) return;
      el.classList.add('reveal');
      io.observe(el);
    });
  }
  reveal();

  /* Recommendations via Section Rendering API */
  var rec = document.querySelector('[data-recommendations]');
  if (rec && rec.getAttribute('data-url')) {
    fetch(rec.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var inner = doc.querySelector('[data-recommendations]');
      if (inner && inner.innerHTML.trim()) { rec.innerHTML = inner.innerHTML; reveal(rec); }
    }).catch(function () {});
  }

  /* Cart page: quantity changes and removal */
  var cart = document.querySelector('[data-cart]');
  if (cart) {
    var updateBtn = cart.querySelector('[data-cart-update]');
    if (updateBtn) updateBtn.hidden = true;
    cart.addEventListener('change', function (e) {
      var input = e.target.closest('[data-line-qty]');
      if (!input) return;
      changeLine(input.getAttribute('data-line-qty'), parseInt(input.value, 10) || 0);
    });
    cart.addEventListener('click', function (e) {
      var a = e.target.closest('[data-line-remove]');
      if (!a) return;
      e.preventDefault();
      changeLine(a.getAttribute('data-line-remove'), 0);
    });
    function changeLine(line, qty) {
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ line: line, quantity: qty }) })
        .then(function (r) { return r.json(); })
        .then(function () { window.location.reload(); })
        .catch(function () { window.location.reload(); });
    }
  }

  /* "Size guide" link beside the size row opens the Size guide accordion */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-size-guide-link]');
    if (!a) return;
    var d = document.querySelector('[data-size-guide]');
    if (!d) return;
    e.preventDefault();
    d.open = true;
    d.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
})();
